"use strict";
angular
  .module("fixParser.services", [], function ($provide) {
    $provide.factory("fileWatchService", function () {
      return new FileWatchService();
    });

    /**
     *
     * @constructor
     */
    function FileWatchService() {
      this.registry = [];
    }

    /**
     * @private
     * @param {File} file
     * @param {function} callback
     */
    const readFile = function (file, callback) {
      const fileReader = new FileReader();
      fileReader.onload = function () {
        const content = this.result;
        callback(content);
      };
      fileReader.readAsText(file);
    };

    /**
     *
     * @param {File} file
     * @param {function} callback
     */
    FileWatchService.prototype.startWatching = function (file, callback) {
      this.registry[file] = callback;

      readFile(file, callback);
    };
  })
  .value("version", "0.1");
